import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styles from '../maintenanceList.module.scss';

const Status = ({ item }) => {
  const options = {
    0: {
      style: styles.new,
      name: 'New'
    },
    1: {
      style: styles.InProgress,
      name: 'In Progress'
    },
    2: {
      style: styles.closed,
      name: 'Closed'
    },
    3: {
      style: styles.Rejected,
      name: 'Rejected'
    },
    7: {
      style: styles.new,
      name: 'New'
    },
    4: {
      style: styles.onhold,
      name: 'On Hold'
    },
    5: {
      style: styles.operations,
      name: 'Operations'
    },
    6: {
      style: styles.unassigned,
      name: 'Unassigned'
    },
    8: {
      style: styles.reviewed,
      name: 'Reviewed'
    },
    9: {
      style: styles.awaitingParts,
      name: 'Awaiting Parts'
    },
    10: {
      style: styles.cancelled,
      name: 'Cancelled'
    },
    11: {
      style: styles.pending,
      name: 'Pending Assignment'
    },
    'New': {
      style: styles.new,
      name: 'Pending Acknowledgment'
    },
    'Approved': {
      style: styles.InProgress,
      name: 'Approved and Work In Progress'
    },
    'Rejected': {
      style: styles.Rejected,
      name: 'Rejected'
    },
    'Cancelled': {
      style: styles.cancelled,
      name: 'Cancelled'
    },
    'Duplicate': {
      style: styles.InProgress,
      name: 'Approved and Work In Progress'
    },
    'Closed': {
      style: styles.closed,
      name: 'Closed'
    }
  };
  return (
    item.status === 12 ? (
      <div
        className={styles.status}
        style={{ backgroundColor: item?.custom_status_color }}
      >
        <FormattedMessage
          id="custom.status"
          defaultMessage={item.custom_status_name}
        />
      </div>
    )
    : (
    <div
     className={options[item]?.style || Object.values(options)?.find(i => i.name === item)?.style}>
      <FormattedMessage id={`lease.maintenance.list.table.status.${options[item]?.name || item}`} defaultMessage={options[item]?.name || item} />
    </div>
    )
  );
};

Status.propTypes = {
  item: PropTypes.number.isRequired
};
export default Status;
